import { computed } from "vue";
import { useAuthStore } from "~/stores/auth";
import { canStudentAccessLearning } from "~/utils/studentAccess";

export function useStudentGamificationAccess() {
  const auth = useAuthStore();
  return computed(
    () =>
      auth.profileLoaded &&
      auth.user.permissions.isStudent &&
      auth.user.featureFlags.student_gamification === true &&
      canStudentAccessLearning(auth.user.studentAccess),
  );
}
